var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":'换电订单数量及负荷率',"isActiveSec":true}}),_c('Chart',{attrs:{"cdata":_vm.cdata,"width":_vm.style.width,"height":_vm.style.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }